import { getPartnerFileDownloadRanking } from 'api';
import Pagination from 'components/Pagination';
import { defaultPageSizeOptions } from 'constant/Pagination/pageSizeOption';
import useErrorNetworkMessage from 'hook/useErrorNetworkMessage';
import useCustomQuery from 'hook/useQuery/useCustomQuery';
import { useEffect, useState } from 'react';
import FileDownloadRankingTable from './FileDownloadRankingTable';
import { TableStyle } from './LayoutDefault/styled';

const FileDownloadRanking = ({
  filterData,
  pageSize,
  countToReset,
  emptyText,
  setIsFilesDownloadTableLoading,
}) => {
  const { useQueryAPI } = useCustomQuery();
  const { isOnline, errorNetWork } = useErrorNetworkMessage();

  const [pageNumber, setPageNumber] = useState(1);

  const { data: fileDownloadRankingList = [], isLoading } = useQueryAPI({
    api: getPartnerFileDownloadRanking,
    key: 'getFileDownloadRankingList',
    params: {
      pageNumber,
      pageSize,
      dateFrom: filterData.dateFrom.format('YYYY-MM-DD'),
      dateTo: filterData.dateTo.format('YYYY-MM-DD'),
      filterId: filterData?.partnerId,
    },
    enabled:
      filterData?.partnerId !== null && filterData?.partnerId !== undefined,
  });

  useEffect(() => {
    setPageNumber(1);
  }, [countToReset, pageSize]);

  useEffect(() => {
    setIsFilesDownloadTableLoading(isLoading);
  }, [isLoading]);

  const handleChangePageNumber = (pageNumber) => {
    if (isOnline) {
      setPageNumber(pageNumber);
    } else {
      errorNetWork();
    }
  };

  return (
    <TableStyle>
      <FileDownloadRankingTable
        dataRaw={fileDownloadRankingList?.data}
        isLoading={isLoading}
        emptyText={isLoading ? '集計中です。' : emptyText}
      />

      <Pagination
        currentPage={pageNumber}
        handlePagingChange={handleChangePageNumber}
        total={fileDownloadRankingList?.data?.total}
        pageSize={pageSize}
        pageSizeOptions={defaultPageSizeOptions}
        isShowTotal={false}
      />
    </TableStyle>
  );
};

export default FileDownloadRanking;
